// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"blade-robotic-lawn-mower_productcontent__Hl1qq"};